import React, { useState } from 'react';

/**
 * TriviaPuzzle — Multiple trivia questions with multiple choice answers.
 *
 * data.questions is an array of:
 *   { prompt: "Question?", options: ["A", "B", "C"], correctAnswer: "B" }
 *   { prompt: "Question?", options: ["A", "B", "C"], allCorrect: true }
 */

export default function TriviaPuzzle({ data, onSolved }) {
  const questions = data.questions;
  const [answers, setAnswers] = useState({});
  const [results, setResults] = useState({});
  const [finished, setFinished] = useState(false);

  const handleSelect = (qIndex, option) => {
    if (finished) return;
    setAnswers((prev) => ({ ...prev, [qIndex]: option }));
    setResults((prev) => ({ ...prev, [qIndex]: null }));
  };

  const handleSubmit = () => {
    const newResults = {};
    let allCorrect = true;

    questions.forEach((q, i) => {
      if (q.allCorrect) {
        newResults[i] = 'correct';
      } else if (answers[i] === q.correctAnswer) {
        newResults[i] = 'correct';
      } else {
        newResults[i] = 'wrong';
        allCorrect = false;
      }
    });

    setResults(newResults);

    if (allCorrect) {
      setFinished(true);
      setTimeout(onSolved, 1200);
    }
  };

  const allAnswered = questions.every((_, i) => answers[i]);

  return (
    <div className="puzzle-trivia">
      {questions.map((q, qIndex) => (
        <div key={qIndex} className="trivia-question">
          <p className="trivia-prompt">{q.prompt}</p>
          <div className="trivia-options">
            {q.options.map((option, oIndex) => {
              const isSelected = answers[qIndex] === option;
              const isCorrect = results[qIndex] === 'correct' && isSelected;
              const isWrong = results[qIndex] === 'wrong' && isSelected;

              return (
                <button
                  key={oIndex}
                  className={`trivia-option ${isSelected ? 'selected' : ''} ${isCorrect ? 'option-correct' : ''} ${isWrong ? 'option-wrong' : ''}`}
                  onClick={() => handleSelect(qIndex, option)}
                  disabled={finished}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      ))}

      {!finished && (
        <button className="puzzle-submit" onClick={handleSubmit} disabled={!allAnswered}>
          Lock in my answers!
        </button>
      )}

      {Object.values(results).some((r) => r === 'wrong') && (
        <p className="puzzle-wrong">Not quite! Try again 🤔</p>
      )}

      {finished && (
        <div className="story-done">
          <span className="story-done-text">You know us too well! 💛</span>
        </div>
      )}
    </div>
  );
}
